import HomeSearchPanel from './HomeSearchPanel.react'

export default HomeSearchPanel
